import angular from 'angular';
import { MeurhAdmissoesBeneficiosFormController } from './beneficios.form.controller';

export class MeurhAdmissoesBeneficiosFormComponent implements angular.IComponentOptions {
	static selector = 'meurhAdmissoesBeneficiosFormComponent';
	static controller = MeurhAdmissoesBeneficiosFormController;
	static template = require('!!html-loader!./beneficios.form.html');
	static transclude = true;
	static bindings = {
		entity: '=',
		form: '<',
		busy: '=',
		action: '<',
	};
}
